import { PayTableLandscapeProperties } from "../landscape/PayTableLandscapeProperties";
/**
 * PayTablePortraitProperties.ts
 */
export class PayTablePortraitProperties extends PayTableLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.animationProperties.scale.set(1.4);
        this.animationProperties.position.set(1187, 935);
        this.backToGameButtonProperties.visible = true;
        this.backToGameButtonProperties.scale.set(1.28);
        this.backToGameButtonProperties.position.set(347, 1558);
        this.backToGameButtonProperties.circleRadius = 150;
    }
}
